export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系与投稿
          </h2>
          <p className="text-foreground-500 text-sm mb-10 max-w-lg mx-auto">
            如有影片推荐、资源反馈或商务合作需求，欢迎通过以下方式联系我们
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-all duration-200">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-4">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">邮件联系</h3>
              <p className="text-foreground-400 text-xs">contact@moguyy.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-all duration-200">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className="ri-message-2-line text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">反馈建议</h3>
              <p className="text-foreground-400 text-xs">提交影片需求或问题反馈</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-all duration-200">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto mb-4">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">商务合作</h3>
              <p className="text-foreground-400 text-xs">广告投放与品牌合作洽谈</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}